var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 13.9023c-.09842-.1169-.21332-.2553-.34094-.4125-.43106-.5312-1.00498-1.2743-1.57791-2.1235-.5739-.8505-1.14062-1.79847-1.56235-2.73983-.42467-.94791-.68547-1.85248-.68547-2.62631 0-2.30385 1.86281-4.16666 4.16667-4.16666 2.30388 0 4.16668 1.86281 4.16668 4.16666 0 .77383-.2608 1.6784-.6855 2.62631-.4217.94136-.9884 1.88933-1.5623 2.73983-.57296.8492-1.14689 1.5923-1.57794 2.1235-.12762.1572-.24253.2956-.34094.4125zM6.33325 6.00016c0 1.19615.97053 2.16667 2.16667 2.16667 1.19614 0 2.16668-.97052 2.16668-2.16667 0-1.19614-.97054-2.16666-2.16668-2.16666s-2.16667.97052-2.16667 2.16666z",
    stroke: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMapPin);
export default __webpack_public_path__ + "static/media/whiteMapPin.9674fde1.svg";
export { ForwardRef as ReactComponent };